// 2026-09-27 US-010: KFS brand green for the two Loyalty pages only (AC-27). antd v5 reads
// its colours from ConfigProvider tokens (the craco less @primary-color does not reach
// them), and a nested ConfigProvider merges with App.tsx's, so this scopes the override to
// its children and leaves every other page's buttons and links untouched.
import { ConfigProvider } from 'antd';
import { ReactNode } from 'react';

const KfsGreen = '#088f42';
const KfsGreenHover = '#076e35';

export const LoyaltyTheme = ({ children }: { children: ReactNode }) => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: KfsGreen,
        colorLink: KfsGreen,
        colorLinkHover: KfsGreenHover,
        colorInfo: KfsGreen,
      },
    }}
  >
    {children}
  </ConfigProvider>
);
